module.exports = __webpack_public_path__ + "static/media/picto-friends-black.6da873f5.svg";